import { ref } from 'vue'

export function useToast () {
  const toasts = ref<string[]>([])
  const add = (message: string) => {
    // id for v-for key
    toasts.value.push(message)
    // 3s + 25ms per letters up to 5s
    const duration = Math.min(3000 + message.length * 25, 5000)
    setTimeout(() => {
      toasts.value.shift()
    }, duration)
  }

  return {
    add,
  }
}
